import { useGetBiomarkersV1BiomarkersGet } from '@/api/generated-catch-backend/biomarkers/biomarkers';
import type { CategoryWithResults } from '@/api/generated-catch-backend/model';
import '@/app/components/dashboard/dashboard-reset.css';
import { CategorySection } from './category-section';

interface BiomarkerDashboardProps {
  categoryRefs?: React.MutableRefObject<Record<string, HTMLDivElement | null>>;
  excludedCategories?: Set<string>;
}

export function BiomarkerDashboard({ categoryRefs, excludedCategories }: BiomarkerDashboardProps) {
  const { data, isLoading, isError, error } = useGetBiomarkersV1BiomarkersGet();
  const categories = data?.categories?.filter((cat) => !excludedCategories?.has(cat.metadata.slug)) || [];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
          <p className="text-sm text-gray-600">Loading your biomarkers...</p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="rounded-lg bg-red-50 p-6 text-center">
        <p className="mb-2 font-semibold text-red-900">Unable to load biomarkers</p>
        <p className="text-sm text-red-700">{error instanceof Error ? error.message : 'An error occurred'}</p>
      </div>
    );
  }

  // If no categories, don't show anything (no results ready yet)
  if (categories.length === 0) {
    return null;
  }

  return (
    <div className="dashboard-reset">
      {categories.map((category: CategoryWithResults) => (
        <CategorySection
          key={category.metadata.slug}
          category={category}
          ref={(el) => {
            if (categoryRefs) {
              categoryRefs.current[category.metadata.slug] = el;
            }
          }}
        />
      ))}
    </div>
  );
}
